import React from 'react';

import BooleanIcon from 'components/BooleanIcon';

import './styles.css';

const IsMember = ({isMember}) => (
  <div className="IsMember">
    <div className="label">is member</div>
    <BooleanIcon className="value" value={isMember} />
  </div>
);

export default IsMember;
